<template>
  <div class="p-tiptapEditor">
    <tiptap-vuetify v-model="editorContent" :extensions="extensions" />
  </div>
</template>

<script>
import {
  // component
  TiptapVuetify,
  // extensions
  History,
  Heading,
  Paragraph
} from 'tiptap-vuetify'

export default {
  name: 'TipTapEditor',
  components: { TiptapVuetify },
  props: {
    content: {
      type: String,
      required: true
    }
  },
  data: () => ({
    extensions: [
      History,
      [
        Heading,
        {
          options: {
            levels: [2, 3, 4]
          }
        }
      ],
      Paragraph
    ]
  }),
  computed: {
    editorContent: {
      get () {
        return this.$props.content
      },
      set (value) {
        this.$emit('change', value)
      }
    }
  },
  beforeDestroy () {
    this.editor.destroy()
  }
}
</script>

<style scoped></style>
